import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-grid-rectangle-icon",
  "use": "icon-grid-rectangle-icon-usage",
  "viewBox": "0 0 9 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 13\" id=\"icon-grid-rectangle-icon\"><title>路径 2</title><path d=\"M1.5,3A1.5,1.5,0,1,1,3,1.5,1.5,1.5,0,0,1,1.5,3Zm0,5A1.5,1.5,0,1,1,3,6.5,1.5,1.5,0,0,1,1.5,8Zm6-5A1.5,1.5,0,1,1,9,1.5,1.5,1.5,0,0,1,7.5,3Zm0,5A1.5,1.5,0,1,1,9,6.5,1.5,1.5,0,0,1,7.5,8Zm-6,5A1.5,1.5,0,1,1,3,11.5,1.5,1.5,0,0,1,1.5,13Zm6,0A1.5,1.5,0,1,1,9,11.5,1.5,1.5,0,0,1,7.5,13Z\" transform=\"translate(0 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol